<template>
  <a :id="blok.anchor" v-if="conditionalDisplay">
    <div
      v-editable="blok"
      ref="blok"
      :class="rootClasses"
      :style="rootStyle"
      v-in-viewport.fully="-100"
      v-in-viewport.once="-100"
    >
      <div
        :class="concatClasses(['blok-container'], child.styles)"
        :key="index"
        v-for="(child,index) in blok.content"
      >
        <component :blok="child" :is="child.component"></component>
      </div>
    </div>
  </a>
</template>
<script>
import HeadingSection from "./HeadingSection.vue";
import TextBlok from "./TextBlok.vue";
import ImageBlok from "./ImageBlok.vue";
import VimeoBlok from "./VimeoBlok.vue";
import CtaButton from './CtaButton.vue';
import LegacyOnboardingCta from './LegacyOnboardingCta.vue';
import SummaryCard from './SummaryCard.vue';
import HTMLSection from './HTMLSection.vue';
import QuestionAnswerList from './questionAnswer/QuestionAnswerList.vue';
import ProfileQuestion from './profile/ProfileQuestion.vue';
import BasketList from './basket/BasketList.vue';
import BasketTotal from './basket/BasketTotal.vue';
import BasketVoucherCode from './basket/BasketVoucherCode.vue';

import { debounce  } from "lodash";

import * as ls from 'local-storage';
import * as Cookie from 'js-cookie';

import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "blok",
  props: {
    blok: Object,
    onScreen: Boolean
  },
  components: {
    HeadingSection,
    TextBlok,
    ImageBlok,
    VimeoBlok,
    CtaButton,
    SummaryCard,
    'html-section': HTMLSection,
    'question-list': QuestionAnswerList,
    ProfileQuestion,
    BasketList,
    'legacy-cta' : LegacyOnboardingCta,
    BasketTotal,
    'basket-voucher-code': BasketVoucherCode
  },
  watch: {
    isOnScreen: function(n,o) {
      this.debouncedOnScreen();
    }
  },
  methods: {
    concatClasses: function(pre,classes,end) {
      return pre.concat(classes).concat(end);
    }
  },
  computed: {
    ...mapState({
      meal_preferences: state => state.profile.meal_preferences
    }),
    rootClasses: function() {
      const b = this.$props.blok;
      return [
        "blok",
        this.blok.component,
        b.contain ? "contained" : "",
        b.layout,
        b.class_overrides,
        b.display_targeting
      ];
    },
    rootStyle: function() {
      return {
        backgroundImage: `url(${this.blok.image})`
      };
    },
    conditionalDisplay: function() {
      const paramConditions = this.$props.blok.parameter_conditions;
      const paramConditionOption = this.$props.blok.conditional_display_match;
      if( paramConditions && paramConditions.length>0) {
        const valid = paramConditions.map( (condition) => {
          const matched = condition.type.map( v => {
            const match = false;
            switch(v) {
              case "cookie":
                return Cookie.get(condition.key)==condition.value;
              case "query_string":
                return this.$route.query[condition.key]==condition.value;
              case "local_storage":
                return ls.get(condition.key)==condition.value;
              case "meal_preferences":
                // console.log(this.meal_preferences[condition.key].toString(),condition.value.toString(),this.meal_preferences[condition.key].toString()==condition.value.toString());
                return this.meal_preferences[condition.key].toString()==condition.value.toString();
            }
          }).reduce((a,v) => {
            // console.log(a,v,a||v);
            return a || v;
          });
          // console.log("--",matched)
          return matched;
        }).reduce( (a,v) => {
          if(paramConditionOption=='all'){
            return a && v;
          } else {
            return a || v;
          }
        });
        // console.log(valid);
        return valid;
      }
      return true;
    }
  }
};
</script>

